import Alpine from 'alpinejs';
import { AlpineComponentTryba } from '../../../scripts/alpine/include/global';
document.addEventListener('alpine:init', () => {
    Alpine.data('initStickyMenu', (): AlpineComponentTryba => {
        return {
            poiInViewport: false,
            activeIndex: 0,
            openSummary: true,
            summaryHeight: 0,
            init() {
                const filterItems = document.querySelectorAll('.stickyLink');
                if (!this.$store.global.isMobile && this.$refs.stickyMenu) {
                    const menuAnchor = this.$refs.stickyMenu;
                    const activeClass = 'sticky-link-active';
                    const sectionOffset = 80;
                    addEventListener("scroll", () => {
                        filterItems.forEach(element => {
                            const id = element.getAttribute("href");
                            const section = id ? document.querySelector(id) : null;
                            if (!section) {
                                return;
                            }

                            const sectionOffsetTop = section.getBoundingClientRect().top + window.scrollY;
                            const sectionHeight = section.getBoundingClientRect().height;
                            const filterOffsetTop = menuAnchor.getBoundingClientRect().top + window.scrollY;

                            if (filterOffsetTop > sectionOffsetTop - sectionOffset && filterOffsetTop < sectionOffsetTop + sectionHeight - sectionOffset) {
                                const activeFilter = menuAnchor.querySelector('.' + activeClass);
                                if (activeFilter) {
                                    activeFilter.classList.remove(activeClass)
                                }
                                if (!element.classList.contains(activeClass)) {
                                    element.classList.add(activeClass)
                                }
                            }
                        });
                    });
                }

                if (this.$refs.summaryContainer) {
                    this.summaryHeight = this.$refs.summaryContainer.getBoundingClientRect().height;
                    this.$refs.summary.style.cssText = `height: ${this.$refs.summaryContainer.getBoundingClientRect().height}px`;
                }
            },
            toggleSummary() {
                if (this.$refs.summary) {
                    if (this.openSummary) {
                        this.openSummary = false;
                        this.$refs.summary.style.height = `0px`;
                    } else {
                        this.openSummary = true;
                        this.$refs.summary.style.height = `${this.$refs.summaryContainer.getBoundingClientRect().height}px`;
                    }
                }
            }
        };
    });
});
